/**
 * Constants and schema definitions for the advanced filter system.
 * Based on the Claude specification for Oblique RevOps filtering.
 */

export const FIELD_TYPES = [
    'text', 'number', 'select', 'multi_select', 'status', 'date', 
    'date_range', 'person', 'multi_person', 'checkbox', 'email', 
    'phone', 'url', 'relation', 'currency', 'percentage', 
    'created_at', 'updated_at', 'created_by', 'formula'
];

export const OPERATOR_MAP = {
    text: ['contains', 'not_contains', 'is', 'is_not', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    email: ['contains', 'not_contains', 'is', 'is_not', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    url: ['contains', 'not_contains', 'is', 'is_not', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    phone: ['contains', 'not_contains', 'is', 'is_not', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    
    number: ['equals', 'not_equals', 'greater_than', 'greater_than_or_equal', 'less_than', 'less_than_or_equal', 'is_empty', 'is_not_empty'],
    currency: ['equals', 'not_equals', 'greater_than', 'greater_than_or_equal', 'less_than', 'less_than_or_equal', 'is_empty', 'is_not_empty'],
    percentage: ['equals', 'not_equals', 'greater_than', 'greater_than_or_equal', 'less_than', 'less_than_or_equal', 'is_empty', 'is_not_empty'],
    
    select: ['is', 'is_not', 'is_empty', 'is_not_empty'],
    status: ['is', 'is_not', 'is_empty', 'is_not_empty'],
    
    multi_select: ['contains', 'not_contains', 'is_empty', 'is_not_empty'],
    
    date: ['date_is', 'date_is_before', 'date_is_after', 'date_on_or_before', 'date_on_or_after', 'date_is_between', 'date_is_within', 'is_empty', 'is_not_empty'],
    date_range: ['date_is', 'date_is_before', 'date_is_after', 'date_on_or_before', 'date_on_or_after', 'date_is_between', 'date_is_within', 'is_empty', 'is_not_empty'],
    created_at: ['date_is', 'date_is_before', 'date_is_after', 'date_on_or_before', 'date_on_or_after', 'date_is_between', 'date_is_within', 'is_empty', 'is_not_empty'],
    updated_at: ['date_is', 'date_is_before', 'date_is_after', 'date_on_or_before', 'date_on_or_after', 'date_is_between', 'date_is_within', 'is_empty', 'is_not_empty'],
    
    person: ['contains', 'not_contains', 'is_empty', 'is_not_empty'],
    multi_person: ['contains', 'not_contains', 'is_empty', 'is_not_empty'],
    created_by: ['contains', 'not_contains', 'is_empty', 'is_not_empty'],
    
    checkbox: ['is_checked', 'is_unchecked'],
    
    relation: ['contains', 'not_contains', 'is_empty', 'is_not_empty'],
    
    formula: [] // Resolved at runtime based on field.formulaOutputType
};

export const OPERATOR_LABELS = {
    'contains': 'contains',
    'not_contains': 'does not contain',
    'is': 'is',
    'is_not': 'is not',
    'starts_with': 'starts with',
    'ends_with': 'ends with',
    'is_empty': 'is empty',
    'is_not_empty': 'is not empty',
    'equals': 'equals',
    'not_equals': 'does not equal',
    'greater_than': 'greater than',
    'greater_than_or_equal': 'greater than or equal to',
    'less_than': 'less than',
    'less_than_or_equal': 'less than or equal to',
    'date_is': 'is',
    'date_is_before': 'is before',
    'date_is_after': 'is after',
    'date_on_or_before': 'is on or before',
    'date_on_or_after': 'is on or after',
    'date_is_between': 'is between',
    'date_is_within': 'is relative to today',
    'is_checked': 'is checked',
    'is_unchecked': 'is unchecked'
};

export const VALUE_REQUIRED_OPERATORS = new Set([
    'contains', 'not_contains', 'is', 'is_not', 'starts_with', 'ends_with',
    'equals', 'not_equals', 'greater_than', 'greater_than_or_equal', 'less_than', 'less_than_or_equal',
    'date_is', 'date_is_before', 'date_is_after', 'date_on_or_before', 'date_on_or_after', 'date_is_between', 'date_is_within'
]);
